<template>
  <q-dialog
    v-model="showDialog"
    transition-show="fade-in"
    transition-hide="fade-out"
  >
    <q-card
      style="width: 400px; min-width: 30%"
      class="q-mx-md"
    >
      <q-card-section class="row items-center q-pb-none">
        <div class="text-h6">
          Other Payment Methods
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          dense
          flat
          round
        />
      </q-card-section>
      <q-card-section
        class="row items-center q-pb-sm"
      >
        <q-btn
          v-for="paymentTypeButton in paymentTypes"
          :key="paymentTypeButton.id"
          :outline="!!split"
          :style="`background: ${paymentTypeButton.color}; color: ${paymentTypeButton.color};`"
          :text-color="getTextColor(paymentTypeButton.color)"
          size="md"
          class="q-pb-sm q-my-sm q-py-sm full-width"
          @click="paymentTypeSelected(paymentTypeButton)"
        >
          {{ $t('payment.actions.payAmountWithMethod', { amount: $n(paymentTypeAmounts[paymentTypeButton.id], 'currency'), method: paymentTypeButton.name }) }}
        </q-btn>
        <q-btn
          v-if="showSavedPaymentMethod"
          :outline="!!split"
          size="md"
          color="primary"
          class="q-pb-sm q-my-sm q-py-sm full-width"
          @click="$emit('saved-payment-method-selected')"
        >
          {{ savedPaymentMethodText }}
        </q-btn>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'PaymentTypeDialog',
  props: {
    paymentTypes: {
      type: Array,
      required: true
    },
    paymentTypeAmounts: {
      type: Object,
      required: true
    },
    split: {
      type: Boolean,
      required: true
    },
    showSavedPaymentMethod: {
      type: Boolean,
      required: true,
      default: false
    },
    savedPaymentMethodText: {
      type: String,
      required: false,
      default: null
    },
    disableSavedPaymentMethod: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['saved-payment-method-selected', 'payment-type-selected'],
  data () {
    return {
      showDialog: false
    }
  },
  methods: {
    paymentTypeSelected (paymentType) {
      this.$emit('payment-type-selected', paymentType)
      this.showDialog = false
    },
    getTextColor (backgroundColor) {
      if (this.split) return backgroundColor

      if (this.$isColorDark(backgroundColor)) {
        return 'white'
      } else {
        return 'black'
      }
    },
    show () {
      this.showDialog = true
    }
  }
}

</script>
